import initializeComponent from 'Shared/react-initialize';
import { bindLightboxImageClicks } from 'Shared/lightbox_image_clicks';
import { ModerationDashboard } from './ModerationDashboard';

// The dashboard injects Post HTML (subject/context prose), whose images
// carry the Postimage renderer's lightbox markup.
bindLightboxImageClicks();
initializeComponent('Moderation', ModerationDashboard);
